//FUNCIÓN QUE MANDA LAS PETICIONES Y REGRESA LA RESPUESTA
const Peticion = async (config, url) => {
    try {
        const respuesta = await fetch(url, config);
        const datos = await respuesta.json();
        return datos;
    } catch {
        return ([]);
    }
}

export default (Peticion)